import { useMemo } from 'react';

import { WorkflowTrackerKind, WorkflowTrackerStatus } from '@/types/schema';

import { useHouseholdWorkflowTrackersContext } from '../contexts/useHouseholdWorkflowTrackersContext';

/**
 * Returns the IDs of the household's diagram artifacts that have a
 * `DiagramGeneration` workflow tracker that is queued or started.
 *
 * A new diagram is pending from the start of its first generation: the backend
 * creates a blank artifact and links it to the tracker.
 */
export function useGeneratingDiagramArtifactIds(): Set<string> {
  const { trackers } = useHouseholdWorkflowTrackersContext();

  return useMemo(() => {
    const ids = new Set<string>();
    for (const tracker of trackers) {
      if (
        tracker.kind === WorkflowTrackerKind.DiagramGeneration &&
        (tracker.status === WorkflowTrackerStatus.Queued ||
          tracker.status === WorkflowTrackerStatus.Started) &&
        tracker.diagramArtifact?.id
      ) {
        ids.add(tracker.diagramArtifact.id);
      }
    }
    return ids;
  }, [trackers]);
}
